import { codeMap } from '@pages/changes/utils/helpers/code-map';
import { countrCode } from '@pages/changes/utils/helpers/CountryCodes';

export const normalizeCountryCode = (incomingCode: string): string => {
  if (!incomingCode) return 'uz';

  const upperCode = incomingCode.toUpperCase();

  // 1. codeMap ichidan topishga harakat qilamiz
  if (codeMap[upperCode]) {
    return codeMap[upperCode]; // masalan: "RUS" => "ru"
  }

  // 2. Agar codeMap'da bo'lmasa, countries listidagi code bilan moslashtiramiz
  const matchedCountry = countrCode?.find(country => upperCode.startsWith(country.code.toUpperCase()));

  if (matchedCountry) {
    return matchedCountry.code; // masalan: "ru"
  }

  // 3. Hech biri mos tushmasa default
  return 'uz';
};
